import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-accent-500"></i>
              </div>
              <span className="font-heading text-base font-semibold text-foreground-950">
                精选gay片导航
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              为成年用户提供专业的gay片资源导航与观看指南，帮助您快速发现高质量的gay片内容。
            </p>
            <p className="text-xs text-foreground-400 mt-3">
              本网站内容仅供成年人浏览。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors">
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">gay片分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-accent-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                contact@gayfilmnav.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm"></i>
                </div>
                安全合规 · 隐私优先
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 精选gay片导航. 仅供成年人浏览.
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供信息参考，请通过正规gay片平台观看内容。
          </p>
        </div>
      </div>
    </footer>
  );
}